import { render, staticRenderFns } from "./DialogoAgregarCuentaApartado.vue?vue&type=template&id=1b9dc885&"
import script from "./DialogoAgregarCuentaApartado.vue?vue&type=script&lang=js&"
export * from "./DialogoAgregarCuentaApartado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports